// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__TKwfA","bigColWidth":"Table_bigColWidth__1hviX","biggerColWidth":"Table_biggerColWidth__3MFuB","row":"Table_row__6inpG","col":"Table_col__2LMjm"};